var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.6 -0.5 15.5 13.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18182 12.1818L1.34091 6.34091C0.875 5.875 0.564394 5.33333 0.409091 4.71591C0.257576 4.09848 0.25947 3.48485 0.414773 2.875C0.570076 2.26136 0.878788 1.72727 1.34091 1.27273C1.81439 0.806818 2.35417 0.498106 2.96023 0.346591C3.57008 0.191288 4.17803 0.191288 4.78409 0.346591C5.39394 0.501894 5.93561 0.810606 6.40909 1.27273L7.18182 2.02273L7.95455 1.27273C8.43182 0.810606 8.97349 0.501894 9.57955 0.346591C10.1856 0.191288 10.7917 0.191288 11.3977 0.346591C12.0076 0.498106 12.5492 0.806818 13.0227 1.27273C13.4848 1.72727 13.7936 2.26136 13.9489 2.875C14.1042 3.48485 14.1042 4.09848 13.9489 4.71591C13.7973 5.33333 13.4886 5.875 13.0227 6.34091L7.18182 12.1818Z",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.26498a8e.svg";
export { ForwardRef as ReactComponent };